module.exports = __webpack_public_path__ + "files/271c6ee970da391507239d83e3f82470.png";


//////////////////
// WEBPACK FOOTER
// ./images/emoji-sheets/flags-4.png
// module id = 1397
// module chunks = 59